(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name JobController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('JobController', JobController);

    JobController.$inject = ['UserService'];

    function JobController(UserService){
        var jc = this;
              jc.data = {};
              jc.error = false;
              jc.success = false;
              jc.pdfName = ""; 
              jc.pdfId = "";
              jc.fieldSaved = false;
              jc.sended = false;

      jc.submit = function(form){
        //evitar doble click
        if (jc.sended) {
           return;
        }
            
        if (form.$valid) {
            jc.error = false;
            jc.success = false;
            jc.sended = true;              
            UserService.SaveJob(jc.data).then(function(response){  
             
              if(response.status == 200) {           
                jc.success = true;
                jc.data.title = '';
                jc.data.description = '';
                jc.data.pdf = '';
                jc.pdfName = '';
                jc.fieldSaved = true;

              }else{
                jc.error = true;
              }
               jc.sended = false; 
            });
          
            }
        }
 
      jc.upload = function(response){
        console.log(response);
            jc.pdfName = response.data.name;
            jc.data.pdf = response.data.file_id;     
       }

  
  





   }
})();